import { Injectable } from '@angular/core';

/**
 * SESSION-SERVICE
 * version: 1.0.0 - 31-Ene-2018
 */
@Injectable()
export class SessionService {
  constructor() { }

  readKey(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }
  saveKey(key: any, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  removeItem(key: any) {
    sessionStorage.removeItem(key);
  }
  clear() {
    sessionStorage.clear();
  }

}


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/session.service.ts